import { render, staticRenderFns } from "./create-batch.vue?vue&type=template&id=3c5d7780&scoped=true"
import script from "./create-batch.vue?vue&type=script&lang=js"
export * from "./create-batch.vue?vue&type=script&lang=js"
import style0 from "./create-batch.vue?vue&type=style&index=0&id=3c5d7780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d7780",
  null
  
)

export default component.exports